import React from 'react'
import Chart from 'react-apexcharts';
import { darken, lighten } from 'polished';
import CircleSkelitonLoader from '../../loader/CircleSkelitonLoader';

const SingleReport = ({ isVisible, handleClickInnerGraph, handleClickInnerData, singleData, singleColor }) => {
    const series_items = [singleData?.payment835_claims, singleData?.payment835lite_claims, singleData?.patientpay_claims, singleData?.correspondence_claims]
    const labels = ['Payment 835', 'Payment 835 Lite', 'Patient Pay', 'Correspondence']
    const curent_labels = []
    series_items?.forEach((i, index) => {
        if (i != 0) {
            curent_labels.push(labels[index])
        }
    })

    const options = {
        chart: {
            id: 'basic-donut-inner',
            type: 'donut',
            toolbar: {
                show: false
            },
            fontFamily: 'Open Sans',
            events: {
                click: handleClickInnerGraph,
                dataPointSelection: handleClickInnerData
            }
        },
        fill: {
            type: 'gradient',
        },
        dataLabels: {
            enabled: true,
            style: {
                colors: ['black']
            },
            dropShadow: {
                enabled: false,
                enabledOnSeries: undefined,
                top: 0,
                left: 0,
                blur: 3,
                opacity: 0.35
            }
        },
        legend: {
            show: true,
            customLegendItems: curent_labels,
            offsetX: 0,
            offsetY: 100,
        },
        tooltip: {
            show: true,
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                const color = w.config.colors[seriesIndex];
                console.log(w)
                let tooltip = ''
                const mainLabel = w.globals.labels[seriesIndex]
                if (mainLabel === "Payment 835") {
                    tooltip = `${mainLabel}:${singleData?.payment835_claims}/${singleData?.payment835_job_count}`
                }
                else if (mainLabel === "Payment 835 Lite") {
                    tooltip = `${mainLabel}:${singleData?.payment835lite_claims}/${singleData?.payment835lite_job_count}`
                }
                else if (mainLabel === "Patient Pay") {
                    tooltip = `${mainLabel}:${singleData?.patientpay_claims}/${singleData?.patientpay_job_count}`
                }
                else if (mainLabel === "Correspondence") {
                    tooltip = `${mainLabel}:${singleData?.correspondence_claims}/${singleData?.correspondence_job_count}`
                }
                return `<div style="background-color:${color};padding:5px" class="">
                        <span style="color:${"#000"};"> ${tooltip}  </span>
                </div>`

            }
        },
        labels: curent_labels,
        colors: [darken(0.1, singleColor), singleColor, lighten(0.1, singleColor), lighten(0.2, singleColor)],

    };
    return (
        isVisible ?
            <CircleSkelitonLoader /> :
            <Chart options={options} series={series_items?.filter(i => i > 0)} type="donut" height={'90%'} />
    )
}

export default SingleReport